<template>
	<el-row>
		<el-row>
			<el-col>
				<el-button @click="add">添加+</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="序号" prop="memberLabelId"> </el-table-column>
					<el-table-column label="人设" prop="name"> </el-table-column>
					<el-table-column label="备注" prop="note"> </el-table-column>
					<el-table-column label="创建时间" prop="created"> </el-table-column>
					<el-table-column label="状态">
						<template slot-scope="scope">
							<el-switch :active-value="0" :inactive-value="1" active-color="#13ce66"
								inactive-color="#ff4949" v-model="scope.row.useStatus" @change="isStatus(scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="viewUser(scope.row)">查看关联用户</el-button>
							<el-button type="text" @click="editor(scope.row)">修改</el-button>
							<el-button type="text" @click="del(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form :model="info" ref="info" :rules="infoRules" label-position="right" label-width="100px">
				<el-form-item label="人设名称：" prop="name">
					<el-input v-model="info.name"></el-input>
				</el-form-item>
				<el-form-item label="备注:" prop="note">
					<el-input v-model="info.note"></el-input>
				</el-form-item>
				<el-form-item label-width="100px">
					<el-button type="info" @click="centerDialogVisible = false">
						取消
					</el-button>
					<el-button type="primary" @click="sub">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="关联用户" :visible.sync="DialogVisible" center>
			<el-table :data="tableData2">
				<el-table-column lable="头像">
					<template slot-scope="scope">
						<el-image :src="scope.row.icon" style="width: 100px;height: 100px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="level"> </el-table-column>
				<el-table-column prop="memberId"> </el-table-column>
				<el-table-column prop="nickName"> </el-table-column>
			</el-table>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				title: "",
				centerDialogVisible: false,
				DialogVisible: false,
				tableData: [],
				tableData2: [],
				options: [],
				info: {
					memberLabelId: '',
					name: '',
					note: ''
				},
				infoRules: {
					name: [{
						required: true,
						message: '请输入人设名称',
						trigger: 'blur'
					}],
					note: [{
						required: true,
						message: '请输入备注',
						trigger: 'blur'
					}],

				}
			};
		},
		methods: {
			//添加
			add() {
				this.centerDialogVisible = true;
				this.title = "新增人设";
				this.info = {
					name: '',
					note: '',
					memberLabelId: ''
				}
			},
			isStatus(row) {
				this.$http.post('/api/plant/clrLabel/updateLabel', {
					"memberLabelId": row.memberLabelId,
					"useStatus": row.useStatus == 0 ? 0 : 1
				}).then(res => {
					if (res.data.status == 0) {
						this.getInfo()
					}
				})
			},
			viewUser(row) {
				this.$http.get(`/api/plant/clrLabel/selectMemberByLabel?labelId=${row.memberLabelId}`, {}).then(res => {
					console.log(res.data.data);
					if (res.data.status == 0) {
						this.tableData2 = res.data.data
						this.DialogVisible = true
					} else {
						this.$message.error('查询失败')
					}
				})
			},
			editor(row) {
				this.centerDialogVisible = true;
				this.title = "编辑人设";
				this.info = {
					name: row.name,
					note: row.note,
					memberLabelId: row.memberLabelId
				}
			},
			del(row) {
				this.$confirm('此操作将永久删除该人设, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/plant/clrLabel/deleteLabel?memberLabelId=${row.memberLabelId}`, {}).then(
						res => {
							console.log(res);
							if (res.data.status == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.getInfo()
							} else {
								this.$message({
									type: 'info',
									message: '删除失败'
								});
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//确认
			sub() {
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.title == '新增人设') {
							this.$http.post('/api/plant/clrLabel/insertLabel', {
								type: 4,
								name: this.info.name,
								note: this.info.note
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('添加失败')
								}
							})
						} else {
							this.$http.post('/api/plant/clrLabel/updateLabel', {
								type: 4,
								memberLabelId: this.info.memberLabelId,
								name: this.info.name,
								note: this.info.note
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('更新失败')
								}
							})
						}
					}
				})
			},
			getInfo() {
				this.$http.post("/api/plant/clrLabel/selectLabel", {
					"type": 4
				}).then(res => {
					console.log(res.data.data);
					this.tableData = res.data.data
				})
			},
		},
		created() {
			this.getInfo()
		}
	};
</script>

<style scoped>
</style>
